import axios from 'axios';
import config from '../config';

declare module 'axios' {
  export interface AxiosRequestConfig {
    authorizedRequest?: boolean;
  }
}

export const PAGE_SIZE = 5;

const axiosInstance = axios.create({
  baseURL: config.apiBaseUrl,
});

export default axiosInstance;
